import React from 'react';
import {Check} from "@phosphor-icons/react";

const IconCheck = (props) => (
    <Check {...props}/>
);

export default IconCheck;
